import styled from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  margin-top: 50px;
  padding: 0 34px;

  * {
    margin: 0;
    padding: 0;
  }

  @media only screen and (min-width: 800px) {
    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;

  display: flex;
  align-items: center;
  flex-direction: column;

  gap: 26px;

  margin-bottom: 80px;

  .svg-image {
    aspect-ratio: 138 / 154;
    width: 140px;
  }

  .group {
    display: flex;
    align-items: center;
    flex-direction: column;

    gap: 22px;

    max-width: 560px;

    .title {
      color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#051226')};
      font-size: 18px;
      font-weight: 700;
      line-height: 120%;
    }

    .description {
      color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#222')};

      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 170%;
    }

    .link-button {
      background-color: rgb(${({ theme }) => theme.primary.base});
      padding: 10px 16px;
      border-radius: 4px;
      color: white;
      font-size: 14px;
      font-weight: 700;
      line-height: 130%;

      color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};
    }
  }

  @media only screen and (min-width: 800px) {
    margin-bottom: 120px;

    .svg-image {
      width: 282px;
    }

    .group {
      gap: 0;

      .title {
        font-size: 30px;
        margin-bottom: 22px;
      }

      .description {
        font-size: 16px;
        line-height: 30px;
        margin-bottom: 8px;

        margin-bottom: 32px;
      }

      .link-button {
        font-size: 16px;
        padding: 14px 21px;
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    flex-direction: row;
    justify-content: center;

    gap: 52px;

    .group {
      align-items: flex-start;

      .description {
        text-align: start;
      }
    }
  }
`
